const formatCalendarDay = (day: string | Date) =>
    day instanceof Date
        ? day
              .toLocaleDateString("en", {
                  weekday: "short"
              })
              .substring(0, 1)
        : day.substring(0, 1);

export default formatCalendarDay;
